

import { Heading as TiptapHeading } from '@tiptap/extension-heading'

// If you already have a generic dropdown button component, point to it here.
// This name/path matches your existing pattern; change if your file differs.
import { HeadingActionMenuButton } from '@/tiptap/extensions/components/ActionMenuButton/index'

export default TiptapHeading.extend({
  addOptions() {
    const parent = typeof this.parent === 'function' ? this.parent() : {}
    return {
      ...parent,
      levels: [1, 2, 3, 4, 5, 6],
      button: ({ editor, extension, t }) => ({
        component: HeadingActionMenuButton,
        componentProps: {
          editor,
          extension,
          t,
        },
      }),
    }
  },
})